import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fr from 'facet-rest';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';

const styles = theme => ({
  root: {
    fontWeight: theme.typography.fontWeightBold,
  },
});

const BackButton = ({
  className,
  classes,
}) => {
  const { pageContentResource, loadPageContentLink } = usePageContentContext();
  return (
    <IconButton
      className={classNames(classes.root, className)}
      onClick={() => {
        loadPageContentLink(pageContentResource.relationship(fr.relationships.back.name).link('related'));
      }}
      color={'primary'}
      icon={ArrowBackIcon}
      title={'Back'}
    />
  );
};

BackButton.defaultProps = {
  className: '',
};

BackButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(BackButton);
